'use client';

// import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
// import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export default function FrontendObservability() {
    // skip if already initialized
    // if (faro.api || true) {
    //     return null;
    // }
    //
    // try {
    //     const faro = initializeFaro({
    //
    //         url: process.env.NEXT_PUBLIC_FARO_URL || "https://localhost:3000/", // || 'https://faro-collector-prod-ap-south-1.grafana.net/collect/4420656e6e76931355f342228ca533a9',
    //
    //         app: {
    //             name: process.env.NEXT_PUBLIC_FARO_APP_NAME || 'farminsta-web:webjs',
    //             namespace: process.env.NEXT_PUBLIC_FARO_APP_NAMESPACE || undefined,
    //             version: process.env.VERCEL_DEPLOYMENT_ID || '1.0.0',
    //             environment: process.env.NEXT_PUBLIC_APP_ENV || 'staging',
    //         },
    //
    //         instrumentations: [
    //             // Mandatory, omits default instrumentations otherwise.
    //             ...getWebInstrumentations({
    //                 enablePerformanceInstrumentation: true
    //             }),
    //
    //             // Tracing package to get end-to-end visibility for HTTP requests.
    //             new TracingInstrumentation({
    //                 instrumentationOptions: {
    //                     propagateTraceHeaderCorsUrls: [/https:\/\/gql.farminsta.com\/*/, /https:\/\/console\.farminsta\.com/]
    //                 }
    //             }),
    //         ],
    //         webVitalsInstrumentation: {
    //             reportAllChanges: true,
    //         },
    //     });
    //
    // } catch (e) {
    //     return null;
    // }
    return null;
}
